module.exports = __webpack_public_path__ + "media/images/Wellness-Shopper-28efc517b52879dd64682042eb11afea.svg";